import { DecimalPipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { SimpleChange } from '@angular/core';

import isNil from 'lodash-es/isNil';
import isPlainObject from 'lodash-es/isPlainObject';

const decimalPipe = new DecimalPipe('en-ZA');

export function ifChanged(prop: SimpleChange, callback: (value: any) => void): void {
    if (prop !== undefined && prop.currentValue !== undefined) {
        callback(prop.currentValue);
    }
}

export function buildQueryParams(source: Object): HttpParams {
    let target: HttpParams = new HttpParams();
    Object.keys(source).forEach((key: string) => {
        let value: any = source[key];
        if (isNil(value)) {
            return;
        }
        if (isPlainObject(value)) {
            value = JSON.stringify(value);
        } else {
            value = value.toString();
        }
        target = target.append(key, value);
    });
    return target;
}

export function formatCurrencyAbbreviated(value: number): string {
    if (value >= 1_000_000_000) {
        return 'R ' + (value / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    } else if (value >= 1_000_000) {
        return 'R ' + (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (value >= 1_000) {
        return 'R ' + (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    } else {
        return 'R ' + decimalPipe.transform(value, '1.2-2', 'en-ZA') || '';
    }
}

